<p-tree #tree [value]="lista || []" selectionMode="single" [(selection)]="selectedItem"
    (onNodeSelect)="nodeSelect($event)" (onNodeUnselect)="nodeUnselect($event)" [metaKeySelection]="true"
    scrollHeight="345px" [filter]="true"></p-tree>